module.exports = __webpack_public_path__ + "img/75.2.TN.8b5380e3.png";